export const GLOBAL_EVENTS = {
    ADD_TO_CART:'add_to_cart',
    CHANGE_CART_COUNT:'change_cart_count',
    CHANGE_CART_DATA:'change_cart_data',
    LOAD_MORE_CATALOG_ITEMS:'load_more_catalog_items',
    LOAD_MORE_ORDERS:'load_more_orders',
    GET_ADD_SALE_SUMM:'get_add_sale_summ',
    LOAD_CART_DATA: 'load_cart_data',
}
